<!-- LOADER FULL RESTRICTIVO -->
<section class="block-screen-loading">
  <div class="loader"></div>
  <p class="msg" *ngIf="message">{{message}}</p>
</section>
